<img [alt]="title" src="/dist/img/no-results.svg" width="144" height="144" />
<div class="title">{{ title }}</div>
<div class="description">{{ description }}</div>
